import React from "react";
import PropTypes from "prop-types";
import { compose } from "recompose";
import { connect } from "react-redux";
import { Typography, withStyles } from "@material-ui/core";
import RouterIcon from '@material-ui/icons/Router';
import { themeTypeToBool } from '../../../../utils/helpers';
import DeviceSettings from "./DeviceDetails/DeviceSettings";
import Data from "./DeviceDetails/Data";
import Sms from "./DeviceDetails/Sms";
import t from "../../../../languages/pl";
import { bindActionCreators } from 'redux';
import ActionCreator from './../../../../store/actions/index';
import withSubordinateUser from './../../../HOC/withSubordinateUser';

const useStyles = theme => ({
  container: {
    margin: theme.spacing(1),
    display: "float",
    float: "right"
  },
  header: {
    display: "flex",
    alignItems: "center",
    marginBottom: theme.spacing(1)
  },
  content: {
    display: "flex",
    flexDirection: "column"
  },
  button: {
    margin: theme.spacing(0.5),
    borderColor: themeTypeToBool(theme.palette.type) ? "#43425D" : "inherit"
  }
});

const CarDevice = props => {
  const { classes, registrationNo, carId, data, settings, smsData, nonAdminUser, gpsState, car } = props;

  const handleSmsOpen = () => {
    props.getSmsList(carId);
  };

  const handleDataOpen = () => {
    props.getData(carId);
  };

  const handleDataUpdate = (period) => {
    props.getData(carId, period.startTime, period.endTime);
  };

  const handleDeviceSettingsOpen = () => {
    props.getDeviceSettings(carId);
  };

  const handleDeviceSettingsSubmit = (data) => {
    props.patchDeviceSettings(carId, data);
  };

  const handleModeChange = async (mode, newState) => {
    props.putSms(carId, mode, newState);
  };

  return (
    <div className={classes.container}>
      <div className={classes.header}>
        <RouterIcon style={{ marginRight: 5 }}/>
        <Typography variant="body1">{t.device}</Typography>
      </div>
      <div>
        {
          !nonAdminUser
          &&
          <Sms
            name={registrationNo}
            gpsState={gpsState}
            data={smsData}
            onDialogOpen={handleSmsOpen}
            onModeChange={handleModeChange}
            car={car}
          />
        }
        <Data
          name={registrationNo}
          data={data}
          onDialogOpen={handleDataOpen}
          onDataUpdate={(period) => handleDataUpdate(period)}
        />
        {
          !nonAdminUser
          &&
          <DeviceSettings
            name={registrationNo}
            data={settings}
            onDialogOpen={handleDeviceSettingsOpen}
            onSubmit={handleDeviceSettingsSubmit}
          />
        }
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  data: state.carsReducer.data,
  settings: state.carsReducer.settings,
  smsData: state.carsReducer.sms
});

const mapDispatchToProps = dispatch => {
  return bindActionCreators(ActionCreator, dispatch);
};

CarDevice.propTypes = {
  classes: PropTypes.object,
  registrationNo: PropTypes.string,
  gpsState: PropTypes.string,
  carId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  car: PropTypes.object,
  //redux
  data: PropTypes.array,
  getData: PropTypes.func,
  settings: PropTypes.object,
  getDeviceSettings: PropTypes.func,
  smsData: PropTypes.object,
  getSmsList: PropTypes.func,
  patchDeviceSettings: PropTypes.func,
  putSms: PropTypes.func,
  //withSubordinateUser
  nonAdminUser: PropTypes.bool
};

export default compose(
  withStyles(useStyles),
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withSubordinateUser
)(CarDevice);
